import { render, staticRenderFns } from "./PickerStorage.vue?vue&type=template&id=0b5153dd&"
import script from "./PickerStorage.vue?vue&type=script&lang=js&"
export * from "./PickerStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports